import React, { useContext } from "react";
import { Button, Icon, Whisper, Popover, Dropdown } from "rsuite";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

import { withTranslation } from "hoc/WithTranslation";
import { downloadFileByUrl } from "utils";
import { APP_TYPE_CLIENT } from "const";
import { useWindowWidth } from "hooks"
import m from "definedMessages";
import { RtlContext } from "App";

const ManualWidget = ({
    lang,
    appType,
    formatMessage
}) => {

    const rtl = useContext(RtlContext);
    const history = useHistory();

    const windowWidth = useWindowWidth();
    const isMobile = windowWidth < 767;

    if (appType !== APP_TYPE_CLIENT) {
        return null;
    }


    // Voice_ARAB_02.04
    // Voice_ENG_02.04

    // const smsFileName = lang === "ar" ? "Manual_ar.pdf" : "Manual.pdf";
    // const smsFileURL = `${process.env.PUBLIC_URL}/${smsFileName}`;
    // const voiceFileName = lang === "ar" ? "Voice_ARAB_02.04.pdf" : "Voice_ENG_02.04.pdf";
    // const voiceFileURL = `${process.env.PUBLIC_URL}/${voiceFileName}`;

    return (<>
        <ManualButton rtl={rtl} onClick={() => history.push(`/manual/${lang}`)}>
            <Icon icon="book2" />
            {!isMobile && <ManualButtonText>
                <span className="mc1">M</span>
                <span className="mc2">A</span>
                <span className="mc3">N</span>
                <span className="mc4">U</span>
                <span className="mc5">A</span>
                <span className="mc6">L</span>
            </ManualButtonText>}
        </ManualButton>
    </>);
}

const ManualButtonText = styled.div`
    && {
        position: absolute;
        width: 60px;
        height: 60px;
        margin: 0px auto;
        top: 0px;
        font-size: 10px;
        color: white;
        font-weight: 600;

        span {
            position: absolute;
            bottom: 0;
            left: 50%;
            width: 20px;
            height: 38px;
            margin-left: -10px;
            line-height: 53px; /* height*2 - font-size */
            text-align: center;
            transform-origin: top center;
        }

        span.mc1 {
            transform: rotate(41deg);
        }
        span.mc2 {
            transform: rotate(23deg);
        }
        span.mc3 {
            transform: rotate(9deg);
        }
        span.mc4 {
            transform: rotate(-9deg);
        }
        span.mc5 {
            transform: rotate(-23deg);
        }
        span.mc6 {
            transform: rotate(-40deg);
        }
    }
`;


const ManualButton = styled(Button)`
    && {
        padding: 0;
        width: 60px;
        height: 60px;
        border-radius: 60px;
        background: linear-gradient(#9399bd, #717797);
        box-shadow: rgba(0, 0, 0, 0.16) 0px 4px 4px;
        position: relative;

        &:before {
            top: 0;
            content: "";
            display: block;
            height: 100%;
            width: 100%;
            position: absolute;
            background: #9399bd;
            z-index: -1;
            opacity: 0;
            transition: opacity 0.2s ease;
        }

        &:hover {
            background: linear-gradient(#9399bd, #717797);
            
            &:before {
                opacity: 1;
            }
        }

        &:focus, 
        &:active, 
        &:active:hover, 
        &:active:focus, 
        &:active.focus {
            background: linear-gradient(#9399bd, #717797);;
        }

        .rs-icon {
            color: #fff;
            font-size: 25px;
            line-height: 0px;
            padding: 22px 16px;
        }

        bottom: 10px;
        position: fixed;
        right: 10px;
        z-index: 10;

        @media (max-width: 767px) {
            bottom: 100px;
            right: 5px;

            width: 36px;
            height: 36px;

            .rs-icon {
                font-size: 16px;
                padding: 18px 10px
            }
        }

        ${props => props.rtl && css`
            left: 10px;
            right: auto;

            .rs-icon {
                color: #fff;
                font-size: 25px;
                line-height: 0px;
                padding: 22px 18px;
            }

            @media (max-width: 767px) {
                left: 5px;
                right: auto;

                .rs-icon {
                    font-size: 16px;
                    padding: 18px 10px
                }
            }
        `}
    }
`;


const mapState = ({ auth }) => ({
    lang: auth.lang,
    appType: auth.appType
});

export default connect(mapState)(withTranslation(ManualWidget));